import { render, staticRenderFns } from "./rightNavi.vue?vue&type=template&id=4e5d69fc&scoped=true&"
import script from "./rightNavi.vue?vue&type=script&lang=ts&"
export * from "./rightNavi.vue?vue&type=script&lang=ts&"
import style0 from "./rightNavi.vue?vue&type=style&index=0&id=4e5d69fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5d69fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Users\\its_bas_sp_schramwy\\serviceportal\\RUB.Serviceportal\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4e5d69fc', component.options)
    } else {
      api.reload('4e5d69fc', component.options)
    }
    module.hot.accept("./rightNavi.vue?vue&type=template&id=4e5d69fc&scoped=true&", function () {
      api.rerender('4e5d69fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rightNavi.vue"
export default component.exports